import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { levelDwellPoint } from "../../../api/data";
import serverList from "../../../components/serverList/serverOptions.vue";
import DataOptions from "../../../components/timeList/dataOptions.vue";
import VxeTable from "@/components/vxeTable/vxeTable.vue";
export default {
  name: "userLevelStay",
  components: {
    serverList: serverList,
    DataOptions: DataOptions,
    VxeTable: VxeTable
  },
  data: function data() {
    return {
      searchInfo: {
        server_id: []
      },
      timedata: [this.$moment().format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      tableData: [],
      tableColumn: [{
        field: "date_str",
        title: "日期",
        sortable: true
      }, {
        field: "server_id",
        title: "服务器id",
        sortable: true
      }, {
        field: "day",
        title: "开服日期",
        sortable: true
      }, {
        field: "role_level",
        title: "角色等级",
        sortable: true
      }, {
        field: "num",
        title: "停留人数",
        sortable: true
      }]
    };
  },
  methods: {
    queryEvent: function queryEvent() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.searchInfo.sdate = _this.timedata[0];
              _this.searchInfo.edate = _this.timedata[1];
              _context.next = 4;
              return levelDwellPoint(_this.searchInfo);
            case 4:
              res = _context.sent;
              if (!res.data.list || res.data.list.length == 0) {
                _this.tableData = [];
                _this.$message({
                  message: "暂无数据",
                  type: "warning"
                });
              } else {
                _this.tableData = res.data.list;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    openPop: function openPop() {
      this.$notify({
        title: "玩家等级停留",
        dangerouslyUseHTMLString: true,
        message: "<div>（1）统计开服前1-7天的玩家等级停留数据</div>" + "<div>（2）根据玩家主线任务日志，只需要统计每个服前1-7天每天的玩家任务停留点</div>" + "<div>（3）可多选需要查询的服务器Id，按天显示所选服务器前7天内每天的任务停留的合计数据</div>" + "<div>（4）任务停留数据展示：开服天数，任务名称（任务进度）（前端根据任务Id，读取任务配置数据），任务停留人数</div>" + "<div>（5）展示数据默认按任务进度降序排序，任务进度大的排前面，可点击对应的数据列名，前端按对应列名重新进行排序</div>" + "<div>（6）点击当天的数据，展开所选服务器列表的分服数据</div>",
        duration: 0
      });
    }
  }
};